import {EquipmentData} from '@hconnect/common/types'
import {Box, MenuItem, TextField} from '@mui/material'
import {EQUIPMENT_TYPE_ICON_MAP} from '@widgets/downtime-analytics'
import {FC, useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type EquipmentSelectorProps = {
  onChange: (id: string) => void
  data: {equipment: EquipmentData}[]
  value?: string
  disabled?: boolean
}

export const EquipmentSelector: FC<EquipmentSelectorProps> = ({
  data,
  disabled,
  onChange,
  value
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const equipments = useMemo<EquipmentData[]>(
    () => data.map((item) => item.equipment).filter(Boolean),
    [data]
  )

  return (
    <TextField
      fullWidth
      variant="filled"
      label={t('stoppageAnalysis.label.selectAsset')}
      select
      disabled={disabled}
      data-test-id="select-asset"
      value={value}
      onChange={(event) => {
        onChange(event.target.value)
      }}
    >
      {equipments.map((equipment) => (
        <MenuItem
          data-test-id={`action-status-dropdown-item-${equipment.id}`}
          key={equipment.id}
          value={equipment.id}
        >
          <Box display="flex" alignItems="center">
            {equipment.equipmentType && EQUIPMENT_TYPE_ICON_MAP[equipment.equipmentType]}
            {equipment.text}
          </Box>
        </MenuItem>
      ))}
    </TextField>
  )
}
